<template>
    <section>
        <canvas ref="historyChart"></canvas>
    </section>
</template>

<script>
    import Chart from 'chart.js'

    export default {
        name: 'History',
        props: ['data'],
        data () {
            return {
                historyChart: null
            }
        },
        watch: {
            data () {
                this.drawHistoryChart()
            }
        },
        methods: {
            drawHistoryChart () {
                const ctx = this.$refs.historyChart
                this.historyChart = new Chart(ctx, {
                    type: 'line',
                    data: {
                        labels: this.data.labels,
                        datasets: [
                            {
                                label: 'Retweets', // 5eb408
                                borderColor: 'rgba(94,180,8,1)',
                                backgroundColor: 'rgba(94,180,8,0.1)',
                                data: this.data.retweets

                            },
                            { // 02bfff
                                label: 'Unique tweets',
                                borderColor: 'rgba(2,191,255,1)',
                                backgroundColor: 'rgba(2,191,255,0.1)',
                                data: this.data.tweets
                            },
                            { // e36fe3
                                label: 'Hashtag exposure (in 1000\'s)',
                                borderColor: 'rgba(227,111,227,1)',
                                backgroundColor: 'rgba(227,111,227,0.1)',
                                data: this.data.exposure.map(x => Math.round(x / 1000))
                            }
                        ]
                    },
                    options: {}
                })
            }
        }
    }
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/History.vue